import { getProperty } from "./property-util";

export const replaceUserKeyword = function (input: string, user: account.User): string {        
    if(user == null){
        return input;
    }

    let returnString = input;

    let keywordRegx = /\$\{[A-Za-z0-9]+\}/g;  
    let matches = keywordRegx.exec(input) ?? [];

    matches.forEach(m => {
        let propKey = m.replace(/^\$\{/,'').replace(/\}$/, '');
        if(Object.keys(user).indexOf(propKey) >= 0) {
            let value = getProperty(user, propKey)?.toString() ?? '';
            returnString = returnString.replace(m, value);
        }
    });

    return returnString;
}